import { useEffect, useState } from 'react';
import SheetMusic from './components/SheetMusic';
import Keyboard from './components/Keyboard'
import MusicPlayer from './components/MusicPlayer';
import IntroMessage from './components/IntroMessage';

const baseUrl = 'https://sheet-music-rl.onrender.com'

const App = () => {
  const [musicData, setMusicData] = useState(null)

  const playStates = ['preview', 'challenge']
  const [playState, setPlayState] = useState(playStates[0])
  const [firstTimeUser, setFirstTimeUser] = useState(false)

  const fetchData = async () => {
    const data = await fetch(`${baseUrl}/generate/${localStorage.getItem('userCookieID')}`)
      .then(response => response.json())
      .then(data => data)
    setMusicData(data)
  }

  useEffect(() => {
    const storedCookieID = localStorage.getItem('userCookieID')
    if (!storedCookieID) {
      // User's first time using the game, create a cookie ID
      setFirstTimeUser(true)
      const id = 'cid' + Math.floor(Math.random() * 1000000)
      localStorage.setItem('userCookieID', id)
    }

    fetchData()
  }, [])
  
  return (
    <div style={{paddingTop: 100, paddingLeft: 100}}>
      {(firstTimeUser) ? <IntroMessage continuePressed={() => setFirstTimeUser(false)} />
      :

      <div>
        {(!musicData) ? <div /> :
        <div>
          <SheetMusic data={musicData}/>
          {(playState == playStates[0]) ? <MusicPlayer musicData={musicData} parentOnDone={() => setPlayState(playStates[1])}/> : <div />}
          {(playState == playStates[1]) ? <Keyboard musicData={musicData} resetMusicData={() => {setMusicData(null); fetchData();}}/> : <div />}
        </div>}
      </div>

      }

    </div>
  )
}

export default App;